<script setup>
  import { ref } from "vue";
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Link, Head } from '@inertiajs/inertia-vue3';
  import BaseButton from "@/Components/BaseButton.vue";
  import BaseIcon from "@/Components/BaseIcon.vue";
  import { mdiPlusCircle, mdiFilePdfBox, mdiFileTableOutline, mdiInformationOutline } from "@mdi/js";
  import CardBox from "@/Components/CardBox.vue";
  import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
  import IconRounded from "@/Components/IconRounded.vue";

  const props = defineProps({
      //records: Array,
      template: String,
      title: String,
      fileName: String,
      levels: Object,
      classrooms: Object,
      //ciclos: Object,
      isAdmin: Boolean,
      isCoord: Boolean,
      plantilla: String

  });
  //let elementsDisabled = getElementsByTagName('input', 'select');
  const loading = ref(false)
  const resource = ref('reportcalification')
  const errors = ref({})
  const error = ref('')
  const form = ref({
    'anio_consulta': '',
    'id_student': 0,
    'id_classroom': 0,
    'id_classroom_ugel': 0,
    'ref_ciclo': '',
    'is_sort_nombre': false,
    'sort_nombre': false,
    'is_sort_puntaje': false,
    'sort_puntaje': false,
  })
  const filters = ref([])
  const records = ref([])
  //const id_classroom = ref(0)
  //const ref_ciclo= ref(0)

  const getRecords = async () => {
    if (props.template == 'calificationsugel') {
      if (form.value.id_classroom_ugel == 0) { // <-- !form.value.ref_ciclo Para Periodo anual
          //this.$message.error('Seleccionar estudante');
          if (!form.value.id_classroom_ugel) error.value = 'Debe escoger un aula'
          if (!form.value.ref_ciclo) error.value += ' Debe escoger un periodo'
          return false;
      } else {
        error.value = '';
      }
    } else if (props.template == 'calificationsbymerito') {
      if (form.value.id_classroom == 0) {
          //this.$message.error('Seleccionar estudante');
          if (!form.value.id_classroom) error.value = 'Debe escoger un aula'
          return false;
      } else {
        error.value = '';
      }
    } else {
      if (form.value.id_classroom == 0 || !form.value.ref_ciclo) {
          //this.$message.error('Seleccionar estudante');
          if (!form.value.id_classroom) error.value = 'Debe escoger un aula'
          if (!form.value.ref_ciclo) error.value += ' Debe escoger un periodo'
          return false;
      } else {
        error.value = '';
      }
    }
    
    loading.value = true;
    records.value = [];
    await axios.post(`/${resource.value}/records`, form.value)
        .then(response => {
            records.value = response.data;
        });
    loading.value = false;
    getTextSelectAula()
  }

  const sortNombre = () => {
      form.value.is_sort_nombre = true;
      form.value.is_sort_puntaje= false;
      form.value.sort_nombre = !form.value.sort_nombre;
      getRecords();
  }

  const exportFile = async (format) => {
    loading.value = true;
    // this.loadingSubmit = true;
    errors.value = {};
    console.log('cr_ugel '+form.value.id_classroom_ugel)
    console.log('cr '+form.value.id_classroom)
    console.log('ciclo '+form.value.ref_ciclo)
    await axios({
        url: `/${resource.value}/export`,
        method: 'POST',
        responseType: 'blob',
        data: {
          'records': records.value,
          'format': format,
          'template': props.template,
          'id_classroom': form.value.id_classroom ? form.value.id_classroom : form.value.id_classroom_ugel,
          //'id_classroom_ugel': form.value.id_classroom_ugel,
          'ref_ciclo': form.value.ref_ciclo,
          'anio_consulta': form.value.anio_consulta
        }
    }).then(response => {
      let res = response.data;
      if (res.type === 'application/json') {
          //this.$message.error('Error al exportar');
          console.log('Error al exportar')
      } else {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        //link.setAttribute('download', 'calificacioness_' + Date.now() + '.' + format);
        if (format == 'preview') {
          link.target = "_blank";
          link.setAttribute('view', props.fileName + '.html');
        } else {
          link.setAttribute('download', props.fileName + '_' + aulaText.value + '.' + format);
        }
        document.body.appendChild(link);
        link.click();
      }
    }).catch(error => {
        console.log(error);
        errors.value = error;
    }).then(() => {
        loading.value = false;
    });
    // this.loadingSubmit = false;
    //

  }

  const number2nota = (notaN) => {
    let nota = parseFloat(notaN).toFixed(2);
    let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
    //console.log(nota)
    return result
  }

  const aulaText = ref('')
  const getTextSelectAula = () => {
    
    var values = props.classrooms.map(function(o) {return o.id}) // <-- Crear una nueva lista con map aplicando una función
    var index = values.indexOf(form.value.id_classroom ? form.value.id_classroom : form.value.id_classroom_ugel)
    //var index = form.value.id_classroom ? form.value.id_classroom : form.value.id_classroom_ugel
    if (form.value.id_classroom_ugel) {
      aulaText.value = props.classrooms[index].label + '-' + props.classrooms[index].ref_mc
    } else {
      aulaText.value = props.classrooms[index].label
    }
    //console.log(index)
    console.log(aulaText.value)
    
  } 
</script>

<template>
    <Head title="Reporte de Calificaciones" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="flex justify-between items-center">
                <div>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                      {{ title }} <!-- In basebutton: @click="route('dashboard')"-->
                      <small class="text-red-600" v-if="error">{{ error }}</small>           
                    </h2> 
                </div>
                <!-- <div>
                    <Link :href="route(rutaPrefijo+'-create')">
                        <BaseButton
                            color="info"
                            :icon="mdiPlusCircle"
                            small
                            label=" Nuevo"
                            class="inline-flex"
                        />
                    </Link>
                </div> -->
            </div>
        </template>

        <div class="py-12">
            <!-- Loader -->
            <div v-if="loading" class="flex flex-col justify-center items-center md:h-[calc(100vh_-113px)] h-[calc(100vh-_114px)] absolute bottom-0 bg-white w-full z-50 bg-opacity-80">
                <!-- LRR Loader Pulso <div class="mb-10">
                    <div class="relative inline-flex">
                        <div class="w-8 h-8 bg-rose-600 rounded-full"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-ping"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-pulse"></div>
                    </div>
                </div> -->
                <div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-10" />
                <p class="text-rose-600">Espere por favor ...</p>
                <!-- LRR Button loader <div>
                    <button type="button"
                        class="inline-flex  items-center btn btn-rose text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg ">
                        <div class="border-rose-400 h-5 w-5 animate-spin rounded-full border-4 border-t-white mr-2" />
                        Cargando
                    </button>
                </div> -->
            </div>
            <div class="container mx-auto sm:px-6 lg:px-8 px-4"><!--max-w-7xl-->
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg" :class="loading ? 'pointer-events-none' : ''">
                    
                    <div class="p-6 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        <!-- <div>
                          <label for="list_periodo-choice">Escoge un periodo:</label>
                          <input type="search" placeholder="Periodo" list="list-periodos" id="list_periodo-choice" name="list_periodo-choice" style="width: 300px;">
                          <datalist
                              id="list-periodos"
                              name="list-periodos"
                              class="flat">
                              <option v-for="option in ciclos" :value="option.id">{{ option.label }}</option>
                          </datalist>
                        </div> -->
                        

                        <div class="mb-4 text-center">
                          <input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="form.anio_consulta"
                                :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR">
                        </div>
                        
                        <div class="mb-4">
                          <li>Tomar en cuenta que la información puede variar si actualizan las calificaciones luego de descargar el reporte.
                            <BaseIcon
                              :path="mdiInformationOutline"
                              size="15"
                              title="La nota Nivel de logro se calcula como la siguiente fórmula;
                              Nota menor a 10.5 = C, Nota mayor o igual a 10.50 y menor a 3.50 = B, Nota mayor o igual a 13.50 y menor a 7.50 = A,
                              Nota mayor o igual a 17.50 y menor a 20 = AD,
                              cualquier otro dato mostrará  Error = E"
                            />
                          </li>
                          <li>Sólo se muestran alumnos activos</li>
                          <li>El promedio A.S. Es el promedio Antes del Simulacro, el D.S. es el promedio Después del Simulacro, depende de este si sube un punto adicional o no.</li>
                        </div>

                        <div class="grid grid-cols-1 gap-3 md:grid-cols-4">
                          
                          <div class="relative">
                            <label class="block font-bold mb-2 ml-2">Nivel</label>
                            <select v-model="form.ref_ciclo" @change="getRecords()"
                              class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="" selected>Todos</option>
                              <option v-for="option in levels" :value="option.id">{{ option.label }}</option>
                              <!-- <option v-if="template=='calificationsugel'" value="B5">Promedio Anual</option> -->
                            </select>
                          </div>

                          <div v-if="template!='calificationsugel'" class="relative">
                          <label class="block font-bold mb-2 ml-2">Aula de estudio</label>
                            <select v-model="form.id_classroom" @change="getRecords()"
                              class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="0" selected>Todas las aulas</option>
                              <option v-for="option in classrooms" :value="option.id">{{ option.label }}</option>
                            </select>
                          </div>
                          <div v-if="template=='calificationsugel'" class="relative">
                            <label class="block font-bold mb-2 ml-2">Aula UGEL</label>
                            <select v-model="form.id_classroom_ugel" @change="getRecords()"
                              class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="0" selected>Seleccionar un aula</option>
                              <option v-for="option in classrooms" :value="option.id">{{ option.label + ' - ' + option.ref_mc }}</option>
                            </select>
                          </div>
                          
                        </div>
                        <!-- <div class="mt-4">
                          <div class="relative">
                            <label class="block font-bold mb-2 ml-1">Estudiante</label>
                            <select v-model="form.id_student" @change="getRecords()"
                              class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="0" selected>Todos</option>
                              <option v-for="option in students" :value="option.id">{{ option.apellidos + ' ' + option.nombres }}</option>
                            </select>
                          </div>
                        </div> -->

                        <div class="mt-4"> <!-- v-if="records.length" -->
                          <!-- <div class="inline-block pr-2 ml-1" @click="exportFile('pdf')">
                            Exportar
                            <IconRounded color="" :icon="mdiFilePdfBox" title="Exportar a PDF" class="ml-1 text-red-800"
                             /> 
                          </div> -->
                          <div class="inline-block ml-4" v-if="$page.props.auth.user.id_rol == 1">
                             <BaseButton
                              :disabled="records.length <= 0"
                              @click="exportFile('preview')"
                              color="info"
                              :icon="mdiFileTableOutline"
                              label="Vista previa"
                              small
                              target="_blank"
                              />
                          </div>
                          <div class="inline-block ml-4">
                             <BaseButton
                              :disabled="records.length <= 0 || loading"
                              @click="exportFile('xlsx')"
                              color="success"
                              :icon="mdiFileTableOutline"
                              label="Exportar"
                              small
                              target="_blank"
                              />
                          </div>
                          <!-- <div v-if="modulo=='payementOrder' && showDownloadTxt && countChecked" class="inline-block">
                            <IconRounded color="" :icon="mdiFileDocument" title="Exportar a txt" class="ml-1 text-blue-700"
                            @click="exportFile('txt')" />
                          </div> -->
                        </div>

                        
                        <CardBox v-if="records.length" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <div class="w-full overflow-x-auto">
                              <table>
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th @click="sortNombre">Nombre
                                      <i v-if="form.is_sort_nombre && form.sort_nombre" class="fas fa-sort-up"></i>
                                      <i v-else-if="form.is_sort_nombre" class="fas fa-sort-down"></i>
                                      <i v-else class="fas fa-sort"></i>
                                    </th>
                                    <th>Bimestre</th>
                                    <th>Curso</th>
                                    
                                    <th title="Promedio Antes del Simulacro">Promedio A.S.</th>
                                    <th title="Resultado de Simulacro">R. Simulacro</th>
                                    <th title="Promedio después del Simulacro">Promedio D.S</th>
                                    <th>Nivel de logro</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in records" :key="row.id">
                                    <td data-label="#">
                                    {{ index + 1 }}
                                    </td>
                                    <td data-label="Nombre">
                                    {{ row.fullname }}
                                    </td>
                                    <td data-label="Bimestre">
                                    {{ row.ref_ciclo }}
                                    </td>
                                    <td data-label="Curso">
                                    {{ row.label_short_course ? row.label_short_course : row.label_course }}
                                    </td>
                                    
                                    <td data-label="Promedio A.S.">
                                    {{ row.promedio }}
                                    </td>
                                    <!--<td data-label="Progress" class="lg:w-32">
                                    <progress
                                        class="flex w-2/5 self-center lg:w-full"
                                        max="100"
                                        :value="row.progress"
                                    >
                                        {{ row.progress }}
                                    </progress>
                                    </td>
                                    -->
                                    <td data-label="R. Simulacro" class="lg:w-1 whitespace-nowrap">
                                      <small
                                        :class="(row.simulacro_admision < 1  ? 'text-red-600' : (row.simulacro_admision == 1  ? 'text-green-600' : ''))"
                                        :title="row.simulacro_admision"
                                        >{{ (row.simulacro_admision == 1 ? 'Aprobado' : (row.simulacro_admision == 2 ? 'Ausente' : 'Desaprobado'))  }}
                                      </small>
                                    </td>
                                    <td data-label="Promedio D.S">
                                      {{ row.promediods }}

                                    </td>
                                    
                                    <td data-label="Nivel de logro">
                                      {{ number2nota(row.promediods) }}

                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                           
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>